<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>供应商名称：{{ titleData.AB_NAME }}</li>
          <li>订单编号：{{ titleData.ORDER_CODE }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>退货日期：{{ titleData.SEND_DAY }}</li>
          <li>退货总金额：{{ totalFee.toFixed(2) }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="GYS_PRICE" label="单价"></el-table-column>
          <el-table-column prop="FIRST_CATEGORY_NAME" label="分类"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="退货金额"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="退货原因"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退货单</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { returnProductFun } from 'api/returnWare';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      titleData: {},
      totalFee: 0,
      companyName: '',
      name: '',
      WHERE: Number(sessionStorage.getItem('where')),
      statusFlag: 0,
      checkData: [],
    };
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    this.name = sessionStorage.getItem('name');
    this.getRecordDetail();
  },
  methods: {
    // ----------------------拉取数据
    getRecordDetail() {
      this.titleData = JSON.parse(sessionStorage.getItem('returnMess'));
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('RETURN_ID')),
      };
      returnProductFun(params)
        .then((result) => {
          if (result.DETAIL && result.DETAIL.length !== 0) {
            this.tableData = result.DETAIL;
            this.totalFee = result.DETAIL.reduce((totalPrice, item) => totalPrice + Number(item.PRODUCT_FEE), 0);
            this.checkData = result.OR[0] ? result.OR[0].DATA : [];
            this.statusFlag = result.OR[0] ? result.OR[0].RN : 0;
          } else {
            this.tableData = [];
            this.totalFee = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    toPrintTable() {
      const html = `
        <div>
          <div class="main">
            <div class="title">${this.companyName}采购退货单</div>
            <div class="head">
              <div class="code" style="font-size: 20px;">供应商：${this.titleData.AB_NAME}</div>
              <div style="font-size: 20px;">日期：${this.titleData.SEND_DAY}</div>
            </div>
            <div class="head">
              <div class="code" style="font-size: 20px;">盘库单编号：${this.titleData.ORDER_CODE}</div>
              <div style="font-size: 20px;">总金额：${this.totalFee.toFixed(2)}</div>
            </div>
            <table border="1" cellspacing="0">
              <div class="el-table__body el-table__header">
                <tr style="font-size: 16px;">
                  <th style="width: 50px">序号</th>
                  <th>产品</th>
                  <th>单位</th>
                  <th style="width: 40px">单价</th>
                  <th style="width: 70px">退货数量</th>
                  <th style="width: 70px">退货金额</th>
                  <th>备注</th>
                </tr>
              </div>
              <div class="el-table__body">
              ${this.tableData.map((item, index) => `
                <tr style="text-align: center; font-size: 20px;">
                  <td> ${index + 1} </td>
                  <td>${item.NAME}</td>
                  <td>${item.TYPE_UNIT}</td>
                  <td>${item.GYS_PRICE}</td>
                  <td>${item.REAL_COUNT}</td>
                  <td>${item.PRODUCT_FEE}</td>
                  <td>${item.PRODUCT_COMMENT}</td>
                </tr>
              `)}
              </div>
            </table>
          </div>
          <div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;
            justufy-content: flex-start; width: 100%; flex-wrap: wrap; row-gap: 20px;">
            <div style="flex: 1 0 33%;">退货人：</div>
            <div style="flex: 1 0 33%;">供应商：</div>
            <div style="flex: 1 0 33%;">主管：</div>
            <div style="flex: 1 0 33%;">制单人：${this.name}</div>
          </div>
        </div>
      `;
      const windows = print(html);
      windows.close();
    },
  },
};
</script>
<style scoped>
  .footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }

  ul {
    list-style: none;
    min-height: 5px;
    padding: 0;
  }

  li {
    margin-bottom: 0;
    line-height: 25px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tableManage/returnProductDetail.vue